var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import { StyledButton, StyledH4, StyledCard } from "./styled";
var ErrorCard = /** @class */ (function (_super) {
    __extends(ErrorCard, _super);
    function ErrorCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorCard.prototype.render = function () {
        var _a = this.props, goBackToTransactions = _a.goBackToTransactions, handleTryAgain = _a.handleTryAgain;
        return (React.createElement(StyledCard, null,
            React.createElement(StyledH4, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.error.text" })),
            React.createElement(StyledButton, { onClick: handleTryAgain, primary: true, full: true },
                React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.error.tryAgain" })),
            React.createElement(StyledButton, { onClick: goBackToTransactions, secondary: true, full: true },
                React.createElement(FormattedMessage, { id: "wallet.tenant.topUp.error.cancel" }))));
    };
    return ErrorCard;
}(PureComponent));
export default ErrorCard;
